import { render, staticRenderFns } from "./PODetail.vue?vue&type=template&id=d36cb7d0"
import script from "./PODetail.vue?vue&type=script&lang=js"
export * from "./PODetail.vue?vue&type=script&lang=js"
import style0 from "./PODetail.vue?vue&type=style&index=0&id=d36cb7d0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports